import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    networkDiv: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "25px 60px 25px 30px",
        border: "1px solid #D4DDE4",
        minHeight: "124px",
        borderRadius: "12px 12px 0px 0px",
        flex: "none",
        order: 1,
        flexGrow: 0,
        margin: "0px 0px"
    },
    divsAlign: {
        display: "flex",
        alignItems: "center"
    },
    networkDiv2: {
        Width: 394,
        minHeight: 44,
        display: "flex",

        fontStyle: "normal",
        fontWeight: 400,
        fontSize: "16px",
        lineHeight: "22px",
        color: "#5B6773",
        [theme.breakpoints.down('sm')]: {
            paddingBottom: "10px"
        },
    },
    awsText: {
        fontWeight: 600,
        fontSize: "16px",
        lineHeight: "22px",
        color: "#091E42",
        [theme.breakpoints.down('sm')]: {
            paddingBottom: "10px"
        },

    },
    usEastTxt: {
        fontStyle: "normal",
        fontWeight: 600,
        fontSize: "16px",
        lineHeight: "22px",
        paddingLeft: "2.5px",

    },
    usEastAlign: {
        display: "flex",
        justifyContent: "flex-end",
        [theme.breakpoints.down('md')]: {
            justifyContent: "flex-start",
        },
        [theme.breakpoints.down('sm')]: {
            justifyContent: "flex-start",
        },
    },
    privateButton: {
        marginTop: "10px",
        padding: "10px 30px",
        display: "flex",
        minWidth: "198px",
        minHeight: "42px",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        background: "#FFFFFF",
        border: "1px solid #D4DDE4",
        boxSizing: "border-box",
        borderRadius: "4px",
        fontStyle: "normal",
        fontWeight: 600,
        fontSize: "14px",
        lineHeight: "22px",
        letterSpacing: "-0.1px",
        cursor:"pointer",
        color: "#5B6773"
    }
}))